import cn from 'classnames'
import { Breadcrumb as BreadcrumbAntd } from 'antd'
import { NavLink } from 'react-router-dom'
import { ReactComponent as ArrowForwardIcon } from 'assets/svg/ArrowForward.svg'
import { TBreadcrumb } from './types'
import './styles.scss'

const Breadcrumb = ({ ...props }: TBreadcrumb) => (
  <BreadcrumbAntd
    className={cn('breadcrumb-default', props.className)}
    separator={<ArrowForwardIcon />}
  >
    {props.items.map((item, idx) =>
      item?.href ? (
        <BreadcrumbAntd.Item key={item.href}>
          <NavLink to={item.href} state={item.state}>
            {item.children}
          </NavLink>
        </BreadcrumbAntd.Item>
      ) : (
        <BreadcrumbAntd.Item
          className="breadcrumb-current"
          children={item.children}
          key={`${idx}.${idx}`}
        />
      )
    )}
  </BreadcrumbAntd>
)

//[NOTE] if it's needed export other types of breadcrubs like Breadcrubs.Smth here

export default Breadcrumb
